import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatChargeCode'
})
export class FormatChargeCodePipe implements PipeTransform {
    transform(value: string): string {
        if (!value) return '';

        const words = value.trim().split(/\s+/);
        const totalWords = words.length;

        if (totalWords <= 2) {
            // For short strings, no break needed
            return value;
        }

        const mid = Math.ceil(totalWords / 2); // Break into two lines
        const firstLine = words.slice(0, mid).join(' ');
        const secondLine = words.slice(mid).join(' ');

        return `${firstLine}<br />${secondLine}`;
    }
}
